import { useMutation } from '@tanstack/react-query';

export default function useDuplicateProvidedJobPost() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;

  return useMutation({
    mutationFn: async ({ id }: { id: number }) => {
      const response = await fetch(`/agent/api/provided_job_posts/${id}/duplicate`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to duplicate job post');
      }

      const data = await response.json();
      return data;
    },
  });
}
